import React from 'react';

import QuizSubjectTopics from '../../topics/QuizSubjectTopics';

function QuizMathTopics() {
  
  return (
   <>

 
   
   <QuizSubjectTopics name="quiz" link="quiz/math" type="quiz" subject="math" topic="atoz" subjectName="math" />
   
  

   </>
  );
}

export default QuizMathTopics;